if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      var total_option = parseInt($('.bundle-selects .set').length);
     var count = 0;
      var arr=[];
      var ids = [];
      var qauntity = $('.product__info-wrapper').find('.quantity__input').val();
      if(total_option > 0){
        $('.bundle-selects .set').each(function(i,v){
          var inputs = 0;
          if($(this).find('.optionWrapper input').is(':checked')){
            count = count+1;
            inputs = inputs+1;
            var items = {};
            var id = $(this).find('.optionWrapper input:checked').val(); 
            var qauntity = $(this).parents('.product__info-wrapper').find('.quantity__input').val();
            if (ids.indexOf(id) == -1) {
              items.id = id;     
              items.quantity = qauntity * $('.bundle-selects .optionWrapper input:checked[value="'+id+'"]').length;
              arr.push(items);
            } else {
            }
            ids.push(id);
          }
          if(inputs == 0){
            $(this).addClass('hasError');
            document.getElementById('Bundle').scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
          else{
            $(this).removeClass('hasError');
          }
        });
        if(count == total_option){
          var __this = this;
          __this.submitButton.setAttribute('aria-disabled', true);
      __this.submitButton.classList.add('loading');
      __this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
           $.ajax({
            type : 'POST',
            url : '/cart/add.js',
            dataType : 'json',
            async:true,
            data : {items:arr},
            success : function(data){
              __this.submitButton.classList.remove('loading');
              if (!__this.error) __this.submitButton.removeAttribute('aria-disabled');
              __this.querySelector('.loading-overlay__spinner').classList.add('hidden');   
              // return false
               window.location='/cart';
            },
            error : function(){
            }
          });
        }
        else{
          return;
        }
      }
      else{
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cartNotification.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cartNotification.renderContents(response);
//           }
        window.location='/cart';
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
       this.submitButton.classList.remove('loading');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');      
        });
    }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
